import styled from 'styled-components';
const ResultListStyled = styled.div`
  border-radius: 12px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .handle_btn {
    display: flex;
    justify-content: center;
  }
  .content-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .export-wrapper {
    margin: 16px 0;
    padding-left: 32px;
    height: 34px;
    .export {
      width: 107px;
      color: #fff;
      .MuiSvgIcon-root {
        margin-right: 8px;
      }
    }
  }
  .handle_btn {
    color: #1565c0;
    cursor: pointer;
  }
`;
export default ResultListStyled;
